import { FC, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

import { DataTable } from 'components';
import { useAuth } from 'contexts';
import dayjs from 'dayjs';
import { defaultTransactionColumns, transactionDataColumns } from 'pages/transactions/grid/transaction-columns';
import { fetchTransactionsList } from 'services';
import { downloadCsv } from 'services/download-csv';
import { FilterOperator, FilterState, LogicalOperator } from 'utils';

const Completed: FC = () => {
  const navigate = useNavigate();
  const { userProfile } = useAuth();

  const filter: FilterState = {
    logicalOperator: LogicalOperator.AND,
    filters: [
      {
        field: 'completedDate',
        filterOperator: FilterOperator.ON_OR_AFTER,
        value: dayjs().subtract(24, 'hour').toDate()
      }
    ]
  };

  const initialColumns = useMemo(() => {
    return userProfile.columnPreferences.filter(cp => cp.table === 'TRANSACTION').length > 0
      ? userProfile.columnPreferences
          .filter(cp => cp.table === 'TRANSACTION')
          .map(({ column }) => {
            return { field: column, width: 80 };
          })
      : defaultTransactionColumns.map(c => {
          return { field: c, width: 80 };
        });
  }, [userProfile.columnPreferences]);

  return (
    <div className="page" id="gate-completed">
      <div className="page-header">
        <h1>TRANSACTIONS</h1>
        <button className="btn-back d-flex g-2 text-info-dark" onClick={() => navigate('/gate')}>
          BACK TO GATE ACCESS
          <span className="material-icons icon-large">home</span>
        </button>
      </div>
      <div className="flex-fill">
        <DataTable
          fetchData={fetchTransactionsList}
          fetchCsv={downloadCsv('transactions')}
          columns={transactionDataColumns.map(({ renderCell, ...column }) => column)}
          initialFilters={filter}
          initialPage={{ sortField: 'completedDate', sortDirection: 'desc' }}
          initialColumns={initialColumns}
          filterByLocation
        />
      </div>
    </div>
  );
};

export default Completed;
